module.exports = __webpack_public_path__ + "static/media/cns-msc-broadband-NZ-2019.ab123516.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/cns-msc-broadband-NZ-2019.png
 ** module id = 1297
 ** module chunks = 0
 **/